import { Calendar } from '@features/calendar/components/Calendar'
import type { CalendarCardView, CalendarFilterValues } from '@features/calendar/components/Calendar.types'
import { ALL_CALENDAR_SOURCES, CalendarSource } from '@features/calendar/constants'
import { CalendarToolbar } from '@features/calendar/components/CalendarToolbar'
import { Card, Divider, Group, Stack } from '@mantine/core'
import { useViewMode } from '@stores/usePortalModeStore'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo, useState } from 'react'
import { newCalendarEventHashToken } from '@features/calendar/components/NewEventRouteModal'
import { useOpenHashModal } from '@services/router/hashModals'

export const Route = createFileRoute('/_layout/calendar/')({
	component: RouteComponent,
})

function RouteComponent() {
	const [calendarView, setCalendarView] = useState<CalendarCardView>('month')
	const [calendarDate, setCalendarDate] = useState(new Date().toISOString().slice(0, 10))
	const [filters, setFilters] = useState<CalendarFilterValues>({ category: [], audience: [], calendars: [], m365Calendars: [] })
	const openHashModal = useOpenHashModal()
	const viewMode = useViewMode()
	const availableCalendars: CalendarSource[] = useMemo(() => (
		viewMode === 'parent' ? ['college'] : ALL_CALENDAR_SOURCES
	), [viewMode])

	return (
		// <Card withBorder radius="md" p={0} className="h-full min-h-0 shadow-none!">
			<Stack p={0} gap={0} h={'100%'} className="min-h-0">
                <Group p={5} bg='var(--mantine-color-body)'>
                    <CalendarToolbar
                        view={calendarView}
                        onViewChange={setCalendarView}
                        date={calendarDate}
                        onDateChange={setCalendarDate}
                        filters={filters}
                        onFiltersChange={setFilters}
                        availableCalendars={[...availableCalendars]}
                        showNewEventButton
                        onNewEventClick={() => openHashModal(newCalendarEventHashToken)}
                    />
                </Group>
                <Divider />
				<Calendar view={calendarView} date={calendarDate} onDateChange={setCalendarDate} filters={filters} availableCalendars={[...availableCalendars]} />
            </Stack>
		// </Card>
	)
}
